/**
 * 현장사진 (작업 전 · 중 · 후)
 *
 * 4슬롯 항상 펼침 — ℹ 토글 안내 + 슬롯별 4컬럼 그리드(＋ 업로드 셀)
 *
 * [작업사진 자동 찾기]  격자 지원 앱에서, 회원이 환경설정에서 켠 경우에만(기본 꺼짐). 동의창은 환경설정에서 켤 때 한 번
 *   (SettingEnv.toggleAutoFind) — 일지는 묻지 않는다.
 *   시간창은 여기서 ORDER(work_time·done_at·car_workhour)로 계산한다 — 서버 왕복 없음, GPS 없음.
 *   격자(DevicePicker)에 range 를 주면 격자가 listPhotos{since,until} 로 그 시간대 사진만 먼저 받아 추천 구역에 그린다.
 *   사진첩 조회는 기기 안에서 끝나고, 회원이 확정한 사진만 업로드된다. 규격: .ai/app-protocol.md §11-7.
 *
 * [격자 모드의 등록된 사진 줄]  전체허용(격자 인라인)에서는 슬롯 패널을 그리지 않아 등록된 사진과 작업 전/중/후 장수가
 *   시트 안에 보이지 않았다(촬영해도 토스트만, 3.21 출시 2026-10-26). 격자 위에 「등록된 사진」 줄(.dph-reg)을 그려
 *   장수·썸네일(탭 → 뷰어)을 보이고, 등록(order:jobphoto:changed)·삭제(gallery:delete) 때 그 줄만 다시 읽는다.
 *   데이터는 아래 slots 를 그대로 쓴다. 부분·거부 권한의 슬롯 패널은 손대지 않았다.
 *
 * [데이터 구조]
 *   slots = {
 *     'p-before': [{ photoNum, id, host, path, thumbUrl }],
 *     'p-during': [...],
 *     'p-after':  [...]
 *   }
 */
import Util from '../../Common/Util';

// 시간창 규칙 — 앞뒤 30분(첨부된 현장사진 촬영시각의 95.6% 를 잡는다. 60분으로 늘려도 +1.3%p), 상한 12시간(장기 대여가 창을 통째로 넓히지 않게),
// 작업시간이 비면 4시간으로 가정
const FIND_PAD_MS  = 30 * 60 * 1000;
const FIND_MAX_MS  = 12 * 60 * 60 * 1000;
const FIND_DEFAULT_HOURS = 4;

export default class DiaryJobs {
    constructor() {
        this.SLOTS = [
            { key: 'p-before', tag: '작업전', label: '작업 전', icon: '📷' },
            { key: 'p-during', tag: '작업중', label: '작업 중', icon: '🏗' },
            { key: 'p-after',  tag: '작업후', label: '작업 후', icon: '📸' },
        ];
        this.slots = { 'p-before': [], 'p-during': [], 'p-after': [] };
        this.activeSlotKey = null;       // 업로드 진행 중인 슬롯
    }

    destroy() {
        this._dead = true;   // 닫힘 표시 — 늦게 온 목록 응답을 버린다 (DiaryPhotoBase.destroy 주석 참고)
        $j.Ui.Div.destroyByContainer(this);   // 인라인으로 띄운 DevicePicker 도 함께 정리
        $(`#${this.id}`).off();
        $j.Common.EventBus.offNamespace($j.getNS(this));
    }

    init() {
        // 피커 지원 앱이면 '＋업로드' 단계 없이 격자를 허브 탭 안에 바로 인라인으로 띄운다.
        // 미지원(옛앱·PC)이면 기존 슬롯 패널(＋업로드 → 네이티브 업로드)을 그대로 쓴다.
        if ($j.F.App.pickerSupported()) { this._tryAutoFind(); return; }
        this.loadExisting();
    }

    // ─── 작업사진 자동 찾기 ───────────────────────────
    /**
     * 자동 찾기를 시도할 조건 — 회원 설정 `app_config.auto_find_photos` 가 1 일 때만. 기본은 꺼짐이고 값이 없어도 꺼짐이다.
     * 동의는 환경설정에서 스위치를 켤 때 한 번 받는다(SettingEnv.toggleAutoFind) — 일지는 묻지 않는다(2026-10-23, CS 실장 의견).
     * 설정은 회원 app_config(MEMBER.app_config ← g5_members.app_config).
     */
    _autoFindEligible() {
        return parseInt(this._appConfig().auto_find_photos, 10) === 1;
    }

    _appConfig() {
        // MEMBER 는 사이트 부트(mobile_js.blade 의 #site-boot JSON)가 window.MEMBER 로 세운다.
        // 예전엔 `const MEMBER` 라 window 로는 안 보였다 — 어느 쪽이든 읽도록 둘 다 본다.
        const M = (typeof MEMBER !== 'undefined' && MEMBER) ? MEMBER : window.MEMBER;
        if (!M) return {};
        let c = M.app_config;
        if (typeof c === 'string') { try { c = JSON.parse(c); } catch (e) { c = null; } }   // raw JSON 문자열로 올 때
        if (!c || typeof c !== 'object' || Array.isArray(c)) c = {};                       // PHP 빈 배열은 [] 로 온다
        M.app_config = c;
        return c;
    }

    /** 설정 켜짐 → 시간창 → 기첨부 촬영시각 → 격자를 연다. 꺼져 있거나 조건이 안 되면 격자를 평소처럼(추천 구역 없이/이유만) 연다 */
    _tryAutoFind() {
        const self = this;
        if (!this._autoFindEligible()) { this._openInlinePicker(); return; }
        const w = this._workWindow();
        if (!w.range) { this._openInlinePicker({ suggestSkip: w.reason }); return; }
        // 이미 이 오더에 붙은 사진은 추천에서 뺀다 — 촬영시각으로 대조
        $.getJSON(`/m/ajax/order/${this._ordernum()}/job-photos`).then(
            r => { if (!self._dead) self._openInlinePicker({ range: w.range, excludeDates: ((r && r.list) || []).map(p => p.file_date).filter(Boolean) }); },
            () => { if (!self._dead) self._openInlinePicker({ range: w.range, excludeDates: [] }); },
        );
    }

    /**
     * 조회 시간창 — 전역 ORDER 에서 계산한다(서버 photo-search 없음).
     *   시작 = work_time − 30분, 끝 = (done_at ?? 추정 종료) + 30분, 창 상한 12시간(시작 기준으로 자른다).
     *   추정 종료 = car_workdaytype='일' 이고 car_workhour>1 이면 work_time + N일, 아니면 work_time + (car_workhour||4)시간.
     *   수주자(worker_owner_num == 내 소유자코드 / worker_num == 나)가 아니면 찾지 않는다.
     * @return {{range:{since,until,label}|null, reason?:string}}
     */
    _workWindow() {
        const O = (typeof ORDER !== 'undefined' && ORDER) ? ORDER : window.ORDER;
        const M = (typeof MEMBER !== 'undefined' && MEMBER) ? MEMBER : window.MEMBER;
        if (!O || !O.num) return { range: null, reason: '오더 정보를 찾지 못했어요' };
        const me = String(M?.num || ''), owner = String(M?.mem_ownercode || '');
        const isWorker = (owner && String(O.worker_owner_num) === owner) || (me && String(O.worker_num) === me);
        if (!isWorker) return { range: null, reason: '내가 수주한 오더에서만 찾아요. 이 오더는 수주자가 아니에요' };

        const start = this._ts(O.work_time);
        if (start == null || start > Date.now()) return { range: null, reason: '작업시작시각이 없거나 아직 시작 전이라 찾지 않았어요' };
        let end = this._ts(O.done_at);
        if (end == null) {
            const hours = parseFloat(O.car_workhour) || 0;   // 1.5일 — 정수로 자르면 하루짜리 창이 된다
            if (String(O.car_workdaytype || '') === '일' && hours > 1) end = start + hours * 24 * 60 * 60 * 1000;
            else end = start + (hours > 0 ? hours : FIND_DEFAULT_HOURS) * 60 * 60 * 1000;
        }
        if (end < start) end = start;
        let from = start - FIND_PAD_MS, to = end + FIND_PAD_MS;
        if (to - from > FIND_MAX_MS) to = from + FIND_MAX_MS;
        const fmt = ms => {
            const d = new Date(ms), z = n => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())} ${z(d.getHours())}:${z(d.getMinutes())}:${z(d.getSeconds())}`;
        };
        const hm = ms => { const d = new Date(ms); return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`; };
        const d0 = new Date(from);
        return { range: { since: fmt(from), until: fmt(to), label: `${d0.getMonth() + 1}/${d0.getDate()} ${hm(from)}~${hm(to)}` } };
    }

    /** 'YYYY-MM-DD HH:mm:ss'(서버, KST) → ms. 빈값·0000-·형식 오류면 null */
    _ts(v) {
        const s = String(v || '').trim();
        if (!s || s.startsWith('0000-')) return null;
        const m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/.exec(s);
        if (!m) return null;
        const t = new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0), +(m[6] || 0)).getTime();
        return isNaN(t) ? null : t;
    }

    /**
     * 허브 탭 본문에 DevicePicker 격자를 인라인으로 로드 (pickFiles 의 BS 버전과 같은 설정)
     * @param {object} [extra] 추천 구역 옵션 — {range, excludeDates} 또는 {suggestSkip}
     */
    _openInlinePicker(extra = null) {
        const ordernum = this._ordernum();
        const childId = `${this.id}-ddp`;
        // 위: 등록된 사진 줄(.dph-reg, refreshSlots 가 채운다) / 아래: 격자(DevicePicker). 둘을 .dph-inline 이 flex 로 나눈다
        $(`#${this.id}`).html(`
            <div class="dph-inline">
                <div class="dph-reg" style="display:none"></div>
                <div id="${childId}" class="dph-inline-picker"></div>
            </div>`);
        $j.Ui.Div.open({
            id: childId,
            target: '$j.Ui.DevicePicker',
            container: this,
            data: {
                uploadId:   ordernum,
                uploadTag:  'diary1',
                categories: this.SLOTS.map(s => s.tag),          // 작업전·작업중·작업후 칩
                tag:        this.SLOTS[0].tag,
                title:      '작업사진',
                max:        10,
                maxSheet:   10,
                onCommit:      (files, ctx) => this.commitGridPhotos(files, ctx.tag, ctx.tags),
                footerHtml:    this._adFooterHtml(),
                onFooterClick: (e) => this._onPickerFooterClick(e),
                onClose:       () => $j.Ui.BS.close(),           // 인라인 '닫기' → 사진 허브 시트 전체 닫기
                onNotFull:     (perm) => this._showLegacyPane(perm), // 부분·거부 → 기존 슬롯 패널 + 배너로 전환
                backClose: true,   // 사진 전체 허용 격자 — 뒤로가기로 크게 보기·시트를 한 겹씩 닫는다(일지 화면을 벗어나지 않게)
                ...(extra || {}),
            },
        });
        this._initRegBarHandler();
        this.refreshSlots();            // 등록된 사진 줄 채우기 (격자 자체는 listPhotos 로 따로 간다)
    }

    /**
     * 격자 모드 전용 핸들러 — initHandler(슬롯 패널)는 격자 모드에서 불리지 않으므로 여기서 건다.
     * _showLegacyPane 이 패널로 전환할 때 off() 하고 initHandler 가 다시 건다.
     */
    _initRegBarHandler() {
        const $el = $(`#${this.id}`);
        const self = this;

        // 등록된 사진 썸네일 → 뷰어 (슬롯 패널의 .photo-slot-cell 과 같은 동작)
        $el.on('click', '.dph-reg-th', function () {
            self.openViewer($(this).data('key'), parseInt($(this).data('idx'), 10));
        });

        // 접기/펼치기 — 장수 줄은 남기고 썸네일 줄만 접는다
        $el.on('click', '.dph-reg-fold', function () {
            self._regFolded = !self._regFolded;
            $el.find('.dph-reg').toggleClass('is-folded', self._regFolded);
            $(this).text(self._regFolded ? '펼치기 ▾' : '접기 ▴');
        });

        $j.Common.EventBus.on($j.getNS(this), 'order:jobphoto:changed', (e, payload) => self._onJobPhotoChanged(payload));
        $j.Common.EventBus.on($j.getNS(this), 'gallery:delete', (e, payload) => self._onGalleryDelete(payload));
    }

    /** 격자 커밋(촬영·사진 추가)으로 현장사진(phototype=2)이 바뀜 → 목록 재동기화 (슬롯 패널·등록된 사진 줄 공통) */
    _onJobPhotoChanged(payload) {
        const { ordernum, phototype } = payload || {};
        if (String(ordernum) !== String(this._ordernum())) return;
        if (parseInt(phototype, 10) !== 2) return;
        this.refreshSlots();
    }

    /** 뷰어(Gallery)가 서버 삭제까지 끝낸 뒤 → slots 에서만 빼고 슬롯 패널·등록된 사진 줄을 다시 그린다 */
    _onGalleryDelete(payload) {
        const { ordernum, img_id } = payload || {};
        if (String(ordernum) !== String(this._ordernum())) return;
        for (const slot of this.SLOTS) {
            const idx = this.slots[slot.key].findIndex(p => String(p.id) === String(img_id));
            if (idx === -1) continue;
            this.slots[slot.key].splice(idx, 1);
            this.renderSlotGrid(slot.key);
            break;
        }
        this._renderRegBar();
    }

    _allPhotoIds() {
        return this.SLOTS.flatMap(s => this.slots[s.key].map(p => String(p.id)));
    }

    /**
     * 등록된 사진 줄 — 「등록된 사진 N장」 + 작업 전/중/후 장수 + 썸네일(슬롯 순, 태그 표시). 0장이면 한 줄 안내.
     * @param {Set<string>|null} before 다시 읽기 전의 사진 id — 없던 id 는 「방금」으로 표시한다(촬영·추가 직후 확인용)
     */
    _renderRegBar(before = null) {
        const $bar = $(`#${this.id}`).find('.dph-reg');
        if (!$bar.length) return;

        const total = this._allPhotoIds().length;
        if (!total) {
            $bar.html(`
                <div class="dph-reg-h"><span class="dph-reg-title">등록된 사진이 아직 없어요</span></div>
                <p class="dph-reg-empty">촬영하거나 아래 최근 사진에서 골라 추가하면 여기에 보여요</p>`)
                .removeClass('is-folded').show();
            this._regLoaded = true;
            return;
        }

        const cnts = this.SLOTS.map(s => {
            const n = this.slots[s.key].length;
            return `<span class="dph-reg-cnt${n ? '' : ' is-zero'}">${s.icon} ${s.label} <b>${n}</b></span>`;
        }).join('');
        const thumbs = this.SLOTS.flatMap(s => this.slots[s.key].map((p, idx) => {
            const isNew = !!(before && !before.has(String(p.id)));
            return `
                <div class="dph-reg-th${isNew ? ' is-new' : ''}" data-key="${s.key}" data-idx="${idx}" role="button" aria-label="${s.label} 사진 크게 보기">
                    <img src="${p.thumbUrl}" alt="">
                    ${isNew ? '<span class="dph-reg-just">방금</span>' : ''}
                    <span class="dph-reg-tag">${s.tag}</span>
                </div>`;
        })).join('');
        $bar.html(`
            <div class="dph-reg-h">
                <span class="dph-reg-title">등록된 사진 <b>${total}</b>장</span>
                <button type="button" class="dph-reg-fold">${this._regFolded ? '펼치기 ▾' : '접기 ▴'}</button>
            </div>
            <div class="dph-reg-cnts">${cnts}</div>
            <div class="dph-reg-row">${thumbs}</div>
            <div class="dph-reg-hint">탭하면 크게 보기 · 삭제는 크게 보기 화면에서</div>`)
            .toggleClass('is-folded', !!this._regFolded).show();
        this._regLoaded = true;
    }

    /**
     * 부분·거부 권한 — 디바이스 격자 대신 기존 슬롯 패널(등록사진 + ＋업로드)로 전환하고 상단에 권한 배너를 얹는다.
     * 격자는 권한 없이 텅 비므로, 등록사진을 보여주고 ＋업로드는 네이티브 업로드로 처리한다.
     */
    _showLegacyPane() {
        this._notFull = true;                 // draw 배너 + pickFiles 네이티브 분기용
        $j.Ui.Div.destroyByContainer(this);   // 인라인 격자(DevicePicker) 파괴
        $(`#${this.id}`).off();                                   // 격자 모드 핸들러(등록된 사진 줄) 해제 — initHandler 가 다시 건다
        $j.Common.EventBus.offNamespace($j.getNS(this));
        this.loadExisting();                  // 기존 슬롯 패널 렌더 (draw 가 _notFull 배너 포함)
    }

    // ─── 데이터 로드 ──────────────────────────────────
    loadExisting() {
        const self = this;
        const ordernum = this._ordernum();
        $.ajax({
            type: 'GET', url: `/m/ajax/order/${ordernum}/job-photos`,
            success(r) {
                if (self._dead) return;   // 탭이 바뀐 뒤 도착한 응답 — 같은 자리에 다른 탭이 그려져 있다
                if (!r.result || !r.list) return;
                const tagToKey = Object.fromEntries(self.SLOTS.map(s => [s.tag, s.key]));
                // 비우고 채운다 — 격자 모드의 등록된 사진 줄(refreshSlots)이 먼저 채워 둔 채 부분·거부로 넘어오면
                // 그 위에 덧붙어 같은 사진이 두 장씩 보였다(2026-10-26)
                self.SLOTS.forEach(s => { self.slots[s.key] = []; });
                r.list.forEach(p => {
                    const key = tagToKey[p.tag] || 'p-after';  // 태그 미지정 시 작업후로
                    self.slots[key].push({
                        photoNum: p.num,
                        id:       p.img_id,
                        host:     p.host,
                        path:     p.path,
                        thumbUrl: Util.getImageUrl(p.path, p.host, 'x100'),
                    });
                });
            },
            complete() { if (self._dead) return; self.draw(); self.initHandler(); }
        });
    }

    /**
     * 서버에서 사진 목록을 다시 읽어 슬롯 패널(부분·거부)과 등록된 사진 줄(격자 모드)만 갱신
     * (draw/initHandler 재실행 없음 — 핸들러 중복 방지). 둘 중 화면에 있는 쪽만 그려진다.
     * BS 가 다른 target(그리드 피커) 으로 교체돼 DOM 이 사라진 상태면 아무 것도 하지 않는다.
     */
    refreshSlots() {
        const self = this;
        if (!$(`#${this.id}`).length) return;
        const seq = this._regSeq = (this._regSeq || 0) + 1;   // 마지막 요청의 답만 그린다 — 촬영을 빠르게 두 번 하면 답이 뒤바뀌어 올 수 있다

        $.ajax({
            type: 'GET', url: `/m/ajax/order/${this._ordernum()}/job-photos`,
            success(r) {
                if (self._dead) return;   // 탭이 바뀐 뒤 도착한 응답 — 같은 자리에 다른 탭이 그려져 있다
                if (seq !== self._regSeq) return;   // 더 새 요청이 나가 있다
                if (!r || !r.result) return;
                const list = Array.isArray(r.list) ? r.list : [];
                const before = self._regLoaded ? new Set(self._allPhotoIds()) : null;   // 「방금」 표시용
                const tagToKey = Object.fromEntries(self.SLOTS.map(s => [s.tag, s.key]));
                self.SLOTS.forEach(s => { self.slots[s.key] = []; });
                list.forEach(p => {
                    const key = tagToKey[p.tag] || 'p-after';
                    self.slots[key].push({
                        photoNum: p.num,
                        id:       p.img_id,
                        host:     p.host,
                        path:     p.path,
                        thumbUrl: Util.getImageUrl(p.path, p.host, 'x100'),
                    });
                });
                self.SLOTS.forEach(s => self.renderSlotGrid(s.key));   // 슬롯 패널 (없으면 각자 return)
                self._renderRegBar(before);                              // 등록된 사진 줄 (없으면 return)
            },
        });
    }

    // ─── 렌더링 ──────────────────────────────────────
    draw() {
        const slotsHtml = this.SLOTS.map(s => this._slotCardHtml(s)).join('');
        const adOn = this._isAdOn();
        const html = `
        <div class="dph-pane dph-jobs-pane">
            ${this._notFull ? this._permBannerHtml() : ''}
            <div class="dj-ad-consent">
                <div class="dj-ad-text">
                    <h3>
                        <button class="dj-ad-term" type="button" aria-label="작업사진 활용 동의 내용 보기">작업사진 활용 동의</button>
                        <button class="dph-info-btn dj-info-btn" type="button" aria-label="안내">
                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                <circle cx="6.5" cy="6.5" r="5.5" stroke="var(--color-text-secondary)" stroke-width="1.2"/>
                                <text x="6.5" y="10" text-anchor="middle" font-size="8" font-weight="700" fill="var(--color-text-secondary)">i</text>
                            </svg>
                        </button>
                    </h3>
                    <p>동의하면 수주포인트 적립</p>
                </div>
                ${this._isOwner() ? `<span class="dj-ad-switch">
                    <span class="dj-ad-state${adOn ? ' is-on' : ''}">${adOn ? '동의함' : '미동의'}</span>
                    <img class="dj-ad-toggle" src="/img/m/opt_onoffbtn_${adOn ? 'on' : 'off'}_rnw.svg" data-value="${adOn ? 2 : 1}" alt="사진 활용 동의 여부"></span>` : ''}
            </div>
            <div class="dph-info-box dj-info-box" style="display:none;">
                ⭐ 수주포인트 10점<br>
                · 작업 현장 사진 입력 (3장 이상)<br>
                · 삭제 시 포인트가 환원될 수 있습니다.
            </div>
            <div class="dj-slots">${slotsHtml}</div>
        </div>`;

        $(`#${this.id}`).html(html);
        this.SLOTS.forEach(s => this.renderSlotGrid(s.key));
    }

    /** 부분·거부 권한 안내 배너 (기존 패널 상단) — '사진 접근 허용' 누르면 전체접근 요청 */
    _permBannerHtml() {
        return `
        <div class="dph-perm-banner">
            <div class="dph-perm-banner-txt">
                <b>⚠️ 사진 접근이 제한돼 있어요.</b>
                <span>전체 허용하면 최근 사진을 바로 골라 올릴 수 있어요. 지금은 아래 '＋업로드'로 올릴 수 있습니다.</span>
            </div>
            <button type="button" class="dph-perm-banner-btn">사진 접근 허용</button>
        </div>`;
    }

    _slotCardHtml(s) {
        return `
            <div class="photo-slot" data-key="${s.key}">
                <div class="photo-slot-head">
                    <span class="photo-slot-icon">${s.icon}</span>
                    <span class="photo-slot-name">${s.label}</span>
                    <span class="photo-slot-badge"></span>
                </div>
                <div class="photo-slot-body">
                    <div class="photo-slot-grid"></div>
                </div>
            </div>`;
    }

    /** 단일 슬롯 그리드 + 헤더 상태 갱신 */
    renderSlotGrid(key) {
        const $slot = $(`#${this.id}`).find(`.photo-slot[data-key="${key}"]`);
        if (!$slot.length) return;
        const photos = this.slots[key];
        const has = photos.length > 0;

        // 헤더 배지 (사진 있을 때만 노출)
        const $badge = $slot.find('.photo-slot-badge');
        if (has) {
            $slot.addClass('has-photos');
            $badge.removeClass('badge-blue').addClass('badge-green').text(`${photos.length}장`).show();
        } else {
            $slot.removeClass('has-photos');
            $badge.removeClass('badge-green').addClass('badge-blue').hide();
        }

        // 그리드 셀 + ＋ 업로드 셀
        const cells = photos.map((p, idx) => `
            <div class="photo-slot-cell" data-key="${key}" data-idx="${idx}">
                <img src="${p.thumbUrl}" alt="">
            </div>`).join('');
        const addCell = `
            <div class="photo-slot-add" data-key="${key}" role="button" aria-label="사진 업로드">
                <span class="dph-add-plus">+</span>
                <span class="dph-add-label">업로드</span>
            </div>`;
        $slot.find('.photo-slot-grid').html(cells + addCell);
    }

    // ─── 이벤트 ──────────────────────────────────────
    initHandler() {
        const $el = $(`#${this.id}`);
        const self = this;

        // ℹ 토글 (열림 시 버튼 노란 배경 유지)
        $el.on('click', '.dj-info-btn', function () {
            const $btn = $(this);
            const $box = $el.find('.dj-info-box');
            const isOpening = $box.is(':hidden');
            $box.slideToggle(180);
            $btn.toggleClass('on', isOpening);
        });

        // 홍보 및 마케팅 활용동의 토글 (수주포인트 페이지와 동일 동작)
        // 동의 내용 전문 — 설정 「알림·동의 설정」과 같은 본문(mkterm)
        $el.on('click', '.dj-ad-term', () => {
            const modal = $j.Ui.Modal.open({ mode: 'full', panelClass: 'lc-doc-modal', title: '작업사진 활용 동의', html: '<div class="lc-doc">불러오는 중…</div>' });
            $.ajax({ url: '/m/ajax/modal/term', method: 'POST', data: { tag: 'mkterm' } })
                .done((html) => modal.setBody(`<div class="lc-doc">${html || '내용이 없습니다.'}</div>`))
                .fail(() => modal.setBody('<div class="lc-doc">내용을 불러오지 못했습니다.</div>'));
        });
        $el.on('click', '.dj-ad-toggle', function () {
            self.toggleAdConsent($(this));
        });

        // 썸네일 클릭 → 뷰어 오픈
        $el.on('click', '.photo-slot-cell', function () {
            const key = $(this).data('key');
            const idx = parseInt($(this).data('idx'));
            self.openViewer(key, idx);
        });

        // ＋ 업로드 셀
        $el.on('click', '.photo-slot-add', function () {
            const key = $(this).data('key');
            self.pickFiles(key);
        });

        // 권한 배너 '사진 접근 허용' — 전체접근 요청. 전체가 되면 허브를 다시 열어 격자로 복귀한다.
        $el.on('click', '.dph-perm-banner-btn', function () {
            self._awaitingPerm = true;
            if (!$j.F.App.listPhotos({ reselect: true })) {
                self._awaitingPerm = false;
                $j.Ui.Toast.show('warning', '이 버전에서는 사진 권한 재요청을 지원하지 않습니다.');
            }
        });
        // 권한 재요청 응답 — 전체(full)면 허브 재오픈(→ 격자). 아니면 기존 패널 유지.
        $j.Common.EventBus.on($j.getNS(this), 'app:photos', (e, d) => {
            if (!self._awaitingPerm) return;
            self._awaitingPerm = false;
            if (d && d.permission === 'full') {
                $j.Ui.BS.open({ target: '$j.F.Diary.DiaryPhotoHub', fixedHeight: true,
                    data: Object.assign({}, self.parent?.data || {}, { ordernum: self._ordernum(), tab: 'photo' }) });
            }
        });

        // 업로드 결과 수신
        $j.Common.EventBus.on($j.getNS(this), 'upload:image', (e, payload) => {
            if ($j.F.Upload.getContext() !== 'diaryJobs') return;
            const key = self.activeSlotKey;
            if (!key) return;
            const files = Array.isArray(payload) ? payload : [payload];
            self.addPhotosToSlot(key, files);
        });

        // 그리드 피커가 현장사진(phototype=2)을 커밋했을 때 — 슬롯 재동기화
        $j.Common.EventBus.on($j.getNS(this), 'order:jobphoto:changed', (e, payload) => self._onJobPhotoChanged(payload));

        // Gallery 삭제 이벤트 (Gallery 가 서버 삭제까지 처리하므로 슬롯에서만 제거)
        $j.Common.EventBus.on($j.getNS(this), 'gallery:delete', (e, payload) => self._onGalleryDelete(payload));
    }

    // ─── 파일 선택 (디바이스 사진 그리드 피커) ────────
    //
    // BS 는 싱글톤이라 피커를 열면 이 모듈을 품고 있는 DiaryPhotoHub 가 파괴된다.
    // 피커가 커밋 후 되돌아올 수 있도록 허브 재오픈 옵션(hub)을 함께 넘긴다.
    // 구앱·권한거부 시의 네이티브 피커 폴백은 DevicePicker 안에서 처리한다.
    pickFiles(key) {
        this.activeSlotKey = key;
        const slot = this.SLOTS.find(s => s.key === key);
        const ordernum = this._ordernum();
        const hubData = Object.assign({}, this.parent?.data || {}, { ordernum, tab: 'photo' });

        // 격자(전체허용) / 네이티브 폴백(_notFull·옛앱·PC) 판정·분기는 Upload.pickPhotos 공용 헬퍼가 처리
        $j.F.Upload.pickPhotos({
            notFull: this._notFull,
            native: { tag: 'diary1', context: 'diaryJobs', max_sheet: 10, id: ordernum },
            grid: {
                uploadId:   ordernum,
                uploadTag:  'diary1',
                categories: this.SLOTS.map(s => s.tag),               // 작업전·작업중·작업후
                tag:        slot ? slot.tag : this.SLOTS[0].tag,      // 클릭한 슬롯의 칩을 활성화
                title:      '작업사진',
                // 상한이 없으면 한 번에 수십 장이 잡히고, 커밋이 job-photos/add 를 그만큼 동시 POST 한다
                // (건마다 photo_cnt 재계산 + 수주포인트 판정). 폴백 경로의 max_sheet 와 같은 값으로 맞춘다.
                max:        10,
                maxSheet:   10,
                // 현장사진 커밋(job-photos)·마케팅 동의는 도메인 로직이라 피커에 넣지 않고 여기서 주입한다
                onCommit:      (files, ctx) => this.commitGridPhotos(files, ctx.tag, ctx.tags),
                footerHtml:    this._adFooterHtml(),
                onFooterClick: (e) => this._onPickerFooterClick(e),
                hub: { target: '$j.F.Diary.DiaryPhotoHub', fixedHeight: true, data: hubData },
            },
        });
    }

    // ─── 사진 추가 ───────────────────────────────────
    addPhotosToSlot(key, files) {
        const slot = this.SLOTS.find(s => s.key === key);
        if (!slot) return;
        const ordernum = this._ordernum();
        const self = this;

        files.forEach(file => {
            $.post(`/m/ajax/order/${ordernum}/job-photos/add`,
                {
                    img_id: file.id,
                    tag: slot.tag,
                    file_date: file.date || '',
                    file_gps: file.gps || '',
                    gps_address: file.address || '',
                },
                (r) => {
                    if (!r?.result) {
                        $j.Ui.Toast.show('warning', '사진 등록에 실패하였습니다.');
                        return;
                    }
                    self.slots[key].push({
                        photoNum: r.photoNum,
                        id:       file.id,
                        host:     file.host,
                        path:     file.path,
                        thumbUrl: Util.getImageUrl(file.path, file.host, 'x100'),
                    });
                    self.renderSlotGrid(key);
                });
        });
    }

    /**
     * 그리드 피커가 업로드한 파일을 현장사진(phototype=2)으로 커밋 (네이티브 경로 addPhotosToSlot 과 동일 계약).
     * 커밋 시 이 인스턴스는 이미 파괴됐으므로 DOM 은 만지지 않고, 이벤트로만 목록 재동기화를 알린다.
     */
    commitGridPhotos(files, tag, tags) {
        const ordernum = this._ordernum();
        const list = (files || []).filter(f => f && f.id);
        if (!list.length) return Promise.resolve();

        let ok = 0, fail = 0;
        // tags[i] = 그 파일의 태그(추천 셀의 제안 태그 / 최근 격자 셀의 활성 칩). 없으면 단일 tag.
        const posts = list.map((file, i) => Promise.resolve(
            $.post(`/m/ajax/order/${ordernum}/job-photos/add`, {
                img_id: file.id,
                tag: (tags && tags[i]) || tag || '',
                file_date: file.date || '',
                file_gps: file.gps || '',
                gps_address: file.address || '',
            })
        ).then(r => { r && r.result ? ok++ : fail++; }, () => { fail++; }));

        const mixed = Array.isArray(tags) && new Set(tags.filter(Boolean)).size > 1;
        return Promise.all(posts).then(() => {
            if (ok > 0) {
                $j.Common.EventBus.trigger('order:jobphoto:changed', { ordernum, phototype: 2, tag, count: ok });
                $j.Ui.Toast.show('success', `${(!mixed && tag) ? tag + ' ' : ''}사진 ${ok}장을 등록했습니다.`);
            }
            if (fail > 0) $j.Ui.Toast.show('warning', `사진 ${fail}장 등록에 실패하였습니다.`);
        });
    }

    // ─── 전체화면 뷰어 (일지 공통 Gallery 뷰어) ─────
    openViewer(key, idx) {
        const photo = this.slots[key][idx];
        if (!photo) return;
        $j.F.Order.Gallery.init(this._ordernum(), photo.id);
    }

    _ordernum() { return this.data?.ordernum || (typeof ORDER !== 'undefined' ? ORDER['num'] : ''); }

    // ─── 마케팅 활용동의 토글 (is_ad: 0 무응답 · 1 미동의 · 2 동의) ──
    // 이력과 is_ad 를 함께 쓰는 서버 한 곳(MarketingConsentService)으로 보낸다. 대상은 소유자뿐이다.
    _isAdOn() {
        return (typeof MEMBER !== 'undefined') && parseInt(MEMBER.is_ad, 10) === 2;
    }

    _isOwner() {
        return typeof MEMBER !== 'undefined' && MEMBER && String(MEMBER.num) === String(MEMBER.mem_ownercode);
    }

    /** 현재값(cur: 1|2)을 뒤집어 저장 → 성공하면 저장된 is_ad 로 onSaved 호출 */
    _saveAdConsent(cur, onSaved) {
        $.ajax({
            type: 'POST',
            url: '/m/ajax/marketing-consent',
            data: { agree: cur === 2 ? 0 : 1 },
            dataType: 'json',
            success: (res) => {
                if (!res || !res.result) {
                    $j.Ui.Toast.show((res && res.message) || '저장하지 못했습니다.', { type: 'error' });
                    return;
                }
                if (typeof MEMBER !== 'undefined') MEMBER.is_ad = res.is_ad;
                onSaved(res.is_ad);
            },
        });
    }

    toggleAdConsent($img) {
        this._saveAdConsent(parseInt($img.attr('data-value'), 10), (v) => {
            const on = v === 2;
            $img.attr('data-value', v).attr('src', `/img/m/opt_onoffbtn_${on ? 'on' : 'off'}_rnw.svg`);
            $img.siblings('.dj-ad-state').text(on ? '동의함' : '미동의').toggleClass('is-on', on);   // 글자로도 상태를
        });
    }

    // ─── 그리드 피커 푸터: 마케팅 동의 (피커에 주입 — 피커는 내용을 모른다) ──
    /** 피커 푸터에 끼울 마케팅 동의 HTML (피커의 .ddp-ad 스타일 재사용). 소속자에게는 내지 않는다 */
    _adFooterHtml() {
        if (!this._isOwner()) return '';
        const on = this._isAdOn();
        return `<label class="ddp-ad">
            <span class="ddp-ad-box${on ? ' on' : ''}" data-value="${on ? 2 : 1}"></span>
            <span class="ddp-ad-txt">작업사진 활용 동의 <em>(동의하면 수주포인트 적립)</em></span>
        </label>`;
    }

    /** 피커 푸터 클릭 위임 — 마케팅 동의 박스만 처리 (커밋 중 pane 인스턴스는 파괴돼 있어 전달된 요소·전역만 다룬다) */
    _onPickerFooterClick(e) {
        const $box = $(e.target).closest('.ddp-ad-box');
        if (!$box.length) return;
        e.preventDefault();
        this._saveAdConsent(parseInt($box.attr('data-value'), 10), (v) => {
            $box.attr('data-value', v).toggleClass('on', v === 2);
        });
    }
}